import { DummyServer } from "./DummyServer.js";

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export class DummySlotApi {
    constructor({ server = new DummyServer(), delay = 300 } = {}) {
        this._server = server;
        this._delay = delay;
    }

    async spin(params) {
        await wait(this._delay);
        const response = this._server.post("/slot/spin", params);
        return response.data;
    }
}
